import React from "react";
import FinishedMessage from "../organisms/FinishedMessage";
const Welcome = () => (React.createElement(React.Fragment, null,
    React.createElement(FinishedMessage, null)));
export default Welcome;
